import { render, staticRenderFns } from "./BonusSendIndex.vue?vue&type=template&id=5f234aae&scoped=true"
import script from "./BonusSendIndex.vue?vue&type=script&lang=js"
export * from "./BonusSendIndex.vue?vue&type=script&lang=js"
import style0 from "./BonusSendIndex.vue?vue&type=style&index=0&id=5f234aae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f234aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f234aae')) {
      api.createRecord('5f234aae', component.options)
    } else {
      api.reload('5f234aae', component.options)
    }
    module.hot.accept("./BonusSendIndex.vue?vue&type=template&id=5f234aae&scoped=true", function () {
      api.rerender('5f234aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/BonusSend/BonusSendIndex.vue"
export default component.exports